"use client";

import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/app/components/ui/select";
import { useSearchParams } from "next/navigation";
import { Flex, Text } from "@radix-ui/themes";
import { scrollTop } from "@/lib/utils";

interface Props {
  itemCount: number;
  currentPage: number;
  pageSize: number;
}

const sizes = [20, 40, 60, 80, 100];

const AuctionLotSelect = ({ itemCount, currentPage, pageSize }: Props) => {
  const searchParams = useSearchParams();

  const changePageSize = (size: string) => {
    const params = new URLSearchParams(searchParams);

    // Prevent 404 on lot amount change.
    if (parseInt(size) * currentPage > itemCount) {
      params.set("page", Math.ceil(itemCount / parseInt(size)).toString());
    }

    params.set("pageSize", size.toString());
    window.history.pushState({}, '', '?' + params.toString());
  };

  const handleValueChange = (val: string) => {
    changePageSize(val);
    scrollTop();
  }

  return (
    <Flex align="center" gap="2" className="h-0 md:h-min">
      <Text className="text-sm font-medium">Show</Text>
      <Select onValueChange={handleValueChange}>
        <SelectTrigger className="w-[70px] text-sm rounded-none">
          <SelectValue placeholder={pageSize.toString() || "20"} className="text-sm" />
        </SelectTrigger>
        <SelectContent
          ref={(ref) => {
            // Prevent clicks from propagating to components behind this select on wide screens.
            if (!ref) return;
            if (window.matchMedia("(min-width: 1024px)").matches) {
              ref.ontouchstart = (e) => {
                e.preventDefault();
              };
            }
          }}
        >
          <SelectGroup>
            {sizes.map((size) => (
              <SelectItem
                key={size}
                value={size.toString()}
                className="text-sm"
              >
                {size}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </Flex>
  );
};

export default AuctionLotSelect;
